module.exports = __webpack_public_path__ + "static/media/battery.ca0dd372.svg";